const en = {
  translation: {
    // Auth
    login: {
      title: 'Login',
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      password: 'Password',
      passwordPlaceholder: 'Enter your password',
      submit: 'Login',
      error: 'Login error',
      noAccount: "Don't have an account? Register",
      forgotPassword: 'Forgot your password?'
    },
    register: {
      title: 'Register',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      submit: 'Register',
      error: 'Error creating account',
      passwordsDontMatch: 'Passwords do not match',
      hasAccount: 'Already have an account? Login',
      firstNamePlaceholder: 'Enter your first name',
      lastNamePlaceholder: 'Enter your last name',
      emailPlaceholder: 'your@email.com',
      passwordPlaceholder: 'Minimum 6 characters',
      confirmPasswordPlaceholder: 'Repeat your password'
    },
    forgotPassword: {
      title: 'Recover Password',
      email: 'Email',
      submit: 'Send recovery link',
      success: 'A recovery link has been sent to your email',
      error: 'Error sending recovery link',
      backToLogin: 'Back to login',
      description: 'Enter your email and we will send you a link to reset your password.'
    },
    logout: 'Logout',
    cancel: 'Cancel',

    // QuotationScreen translations
    back: 'Back',
    quotationDetails: 'Quotation Details',
    addQuotation: 'Add Quotation',
    clientInfo: 'Client Information',
    clientName: 'Client Name',
    clientEmail: 'Client Email',
    notAvailable: 'Not available',
    detailsTab: 'Details',
    servicesTab: 'Services',
    materialsTab: 'Materials',
    proposalTab: 'Proposal',
    creating: 'Creating...',
    createProject: 'Create Project',
    creationDate: 'Creation Date',
    dateNotAvailable: 'Date not available',
    requestedServices: 'Requested Services',
    service: 'service',
    services: 'services',
    noServicesSpecified: 'No services specified',
    editServices: 'Edit Services',
    perHour: '/hour',
    perDay: '/day',
    fixed: 'fixed',
    quantity: 'Quantity',
    noServicesDescription: 'This quotation does not include specific services or services are not available.',
    additionalInfo: 'Additional Information',
    notSpecified: 'Not specified',
    estimatedTotal: 'Estimated Total',
    availableBusinessServices: 'Available Business Services',
    noBusinessServicesConfigured: 'No services configured in the business profile.',
    requiredMaterials: 'Required Materials',
    noMaterialsSpecified: 'No materials specified',
    editMaterials: 'Edit Materials',
    unit: 'unit',
    noMaterialsDescription: 'This quotation does not include specific materials or materials are not available.',
    additionalMaterialsInfo: 'Additional Materials Information',
    materialsTotal: 'Materials Total',
    discountAmount: 'Discount Amount ($)',
    discountPercentage: 'Discount Percentage (%)',

    // Todo App
    todoApp: {
      title: 'My Todo List',
      addPlaceholder: 'Add new task...',
      addButton: 'Add',
      deleteButton: 'Delete'
    },

    // Language
    language: {
      es: 'Spanish',
      en: 'English'
    },



    // Worker Dashboard
    workerDashboard: {
      loading: 'Loading...',
      errorLoadingDashboard: 'Error loading dashboard data',
      notifications: 'Notifications',
      closeNotifications: 'Close notifications',
      noNotifications: 'You have no new notifications.',
      welcome: 'Welcome, {{name}}',
      status: 'Status',
      active: 'Active',
      pending: 'Pending',
      myProfile: 'My Profile',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      wallet: 'Wallet',
      certifications: 'Certifications',
      issuer: 'Issuer',
      issueDate: 'Issue Date',
      expiryDate: 'Expiry Date',
      approved: 'Approved',
      rejected: 'Rejected',
      date: 'Date',
      viewCertification: 'View Certification',
      downloadCertification: 'Download Certification',
      noCertifications: 'You have no registered certifications. Add a new certification to show your credentials!',
      addCertification: 'Add Certification',
      currentProjects: 'Current Projects',
      noProjects: 'You have no assigned projects',
      onboardingRequired: 'You need to complete the OnBoarding to access all features.',
      onboardingAttention: 'Attention!',
      goToOnboarding: 'Go to OnBoarding',
      noQuotations: 'No quotations available',
      sentQuotations: 'Sent Quotations',
      noSentQuotations: 'No sent quotations',
      field1: 'Field 1',
      field2: 'Field 2',
      noDate: 'No date available',
      clientEmail: 'Email',
      selectWorker: 'Select worker',
      assignmentAccepted: 'The worker has accepted the offer for the task "{{taskTitle}}".',
      assignmentNewJob: 'You have a new job assigned! Task: "{{taskTitle}}".',
      onboardingTitle: 'Complete your OnBoarding!',
      onboardingDescription: 'To access all features, complete your worker profile.',
      onboardingProgress: '{{percent}}% completed',
      onboardingStepIdentity: 'Identity',
      onboardingStepAddress: 'Address',
      onboardingStepExperience: 'Experience',
      onboardingStepPhoto: 'Photo',
      onboardingStepCertifications: 'Certifications',
      onboardingPendingSteps: 'Pending steps: {{steps}}',
      onboardingGoTo: 'Go to OnBoarding',
      assignedTasksTitle: 'Assigned Tasks',
      noAssignedTasks: 'You have no assigned tasks',
      taskStatusNew: 'New',
      taskStatusInProgress: 'In Progress',
      taskStatusDone: 'Completed',
      days: 'days',
      hours: 'hours',
      perHour: '/hour',
      perDay: '/day',
      total: 'Total',
      project: 'Project',
      checklist: 'Checklist',
      goToProfile: 'Go to my profile',
      summaryAssignedProjects: 'Assigned Projects',
      summaryAssignedTasks: 'Assigned Tasks',
      summaryTotalEarnings: 'Total Earnings',
      summaryGeneralProgress: 'General Progress',
      summaryEarningsPending: 'Pending:',
      summaryEarningsReceived: 'Received:',
      assignedBusinesses: 'Assigned Businesses',
      noBusinesses: 'No assigned businesses',
      // Notifications
      notificationsTitle: 'Notifications',
      unreadTab: 'Unread',
      readTab: 'Read',
      noUnreadNotifications: 'No unread notifications',
      noReadNotifications: 'No read notifications',
      notes: 'Notes',
      // Certification statuses
      certificationApproved: '✅ Approved',
      certificationRejected: '❌ Rejected',
      certificationPending: '⏳ Pending',
      // Project statuses
      projectActive: 'Active',
      projectCompleted: 'Completed',
      // Project info
      myPayment: 'My payment',
      myTasks: 'My tasks',
      myProgress: 'My progress',
    },

    // Employee Dashboard
    employeeDashboard: {
      welcome: 'Welcome',
      totalTasks: 'Total Tasks',
      completedTasks: 'Completed Tasks',
      totalHours: 'Total Hours',
      activeProjects: 'Active Projects',
      taskCompletion: 'Task Completion',
      productivity: 'Weekly Productivity',
      recentTasks: 'Recent Tasks',
      viewAll: 'View all',
      noTasks: 'No tasks assigned',
      noProjects: 'No active projects',
      loading: 'Loading dashboard...',
      notifications: 'Notifications',
      employeeId: 'Employee ID',
      locationStatus: 'Location status',
      statusLabel: 'Status',
      active: 'Active',
      pending: 'Pending',
      myProfile: 'My Profile',
      goToProfile: 'View Profile',
      notificationsTitle: 'Notifications',
      unreadTab: 'Unread',
      readTab: 'Read',
      noUnreadNotifications: 'No unread notifications',
      noReadNotifications: 'No read notifications',
      // Chart labels
      chart: {
        completed: 'Completed',
        pending: 'Pending',
        inProgress: 'In Progress',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
        workedHours: 'Worked Hours'
      },
      // Status labels
      status: {
        completed: 'Completed',
        inProgress: 'In Progress',
        pending: 'Pending',
        overdue: 'Overdue',
        unknown: 'Unknown'
      },
      // Priority labels
      priority: {
        high: 'High',
        medium: 'Medium',
        low: 'Low',
        unknown: 'Unknown'
      },
      // Default values
      defaultEmployeeId: 'EMP-001',
      defaultEmployeeName: 'Employee',
      defaultInitial: 'E',
      defaultPosition: 'Employee',
      // Interface text
      hoursSuffix: 'h',
      dueDate: 'Due',
      estimated: 'estimated',
      progress: 'Progress',
      tasks: 'tasks',
      starts: 'Starts',
      // Sectors
      sector: {
        health: 'Health sector',
        construction: 'Construction sector'
      },
      // Errors
      error: {
        loadingUserData: 'Error loading user data'
      },
      // Registration section
      getRegistered: 'Get Registered',
      waitingForAssignment: 'Waiting for Company Assignment',
      assignmentMessage: 'Your dashboard features will be enabled once a company registers you as part of their team.',
      assignmentNote: 'Currently, you can only view your profile. Task management, project tracking, and productivity features will be available after company assignment.',
      startLinkage: 'Start Linkage',
      // Linkage modal
      linkageModal: {
        title: 'Dynamic Linkage Code',
        description: 'Show this dynamic code to your company to establish the connection.',
        instructions: 'Instructions:',
        step1: 'Show this code to your company administrator',
        step2: 'The company will scan your dynamic code',
        step3: 'Once scanned, you will be automatically assigned to the company',
        step4: 'Your dashboard will be updated with company features',
        close: 'Close'
      },
      // Dynamic Linkage Code translations
      dynamicLinkageCode: {
        refreshesEvery30s: 'Refreshes every 30 seconds',
        scanning: 'Scanning for connection...',
        instructions: 'This dynamic code is scannable by any barcode scanner app. Show it to your company administrator.',
        connectionSuccess: 'Connection established successfully!',
        connectionFailed: 'Connection failed. Please try again.',
        waitingForCompany: 'Waiting for company to scan your code...'
      },
                     // Linkage Scanner translations
           linkageScanner: {
             scanEmployeeCode: 'Scan Employee Code',
             scanInstructions: 'Scan the employee\'s dynamic linkage code to assign them to your company',
             scanning: 'Scanning employee code...',
             success: 'Success!',
             error: 'Error',
             pointAtEmployeeCode: 'Point camera at employee\'s linkage code',
             enterManually: 'Enter Manually',
             scannedCode: 'Scanned:',
             employeeFound: 'Employee found!',
             employeeCode: 'Code:',
             assignEmployee: 'Assign Employee',
             assignEmployeeTitle: 'Assign Employee',
             assignmentSuccess: 'Employee assigned successfully!',
             assignmentError: 'Error assigning employee. Please try again.',
             tryAgain: 'Try Again',
             enterCodeManually: 'Enter the employee\'s linkage code:',
             invalidCode: 'Invalid or expired code. Please try again.',
             scanError: 'Error scanning code. Please try again.',
             // Formulario de asignación
             department: 'Department',
             departmentPlaceholder: 'e.g. Engineering',
             role: 'Role',
             rolePlaceholder: 'e.g. Developer',
             position: 'Position',
             positionPlaceholder: 'e.g. Senior Developer',
             hireDate: 'Hire Date',
             salary: 'Salary (optional)',
             salaryPlaceholder: 'e.g. 50000',
             cancel: 'Cancel',
             assign: 'Assign'
           }
    },

    // Employee Register
    employeeRegister: {
      title: 'Employee Registration',
      phone: 'Phone',
      phonePlaceholder: '+1 (555) 123-4567',
      employeeId: 'Employee ID',
      employeeIdPlaceholder: 'EMP-001',
      department: 'Department',
      selectDepartment: 'Select a department',
      position: 'Position',
      selectPosition: 'Select a position',
      hireDate: 'Hire Date',
      fillAllFields: 'Please fill in all required fields',
      creating: 'Creating account...',
      register: 'Register as Employee',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      error: 'Error creating employee account'
    },


    workerProjectView: {
      myTasks: 'My Tasks',
      myProgress: 'My Progress',
      myPayment: 'My Payment',
      duration: 'Duration',
      days: 'days',
      projectDates: 'Project Dates',
      startDate: 'Start Date',
      endDate: 'End Date',
      location: 'Location',
      generalProgress: 'My General Progress',
      myTasksInProject: 'My Tasks in This Project',
      noTasksAssigned: 'You have no tasks assigned to this project',
      checklistProgress: 'Checklist Progress',
      taskLocation: 'Task Location',
      checklist: 'Checklist',
      tabs: {
        tasks: 'My Tasks',
        notes: 'Notes'
      }
    },
    workerTaskView: {
      progress: 'Progress',
      payment: 'Payment',
      duration: 'Duration',
      days: 'days',
      hours: 'hours',
      perHour: '/hour',
      perDay: '/day',
      startDate: 'Start Date',
      endDate: 'End Date',
      completed: 'Completed',
      checklistProgress: 'Checklist Progress',
      status: {
        new: 'Not Started',
        inProgress: 'In Progress',
        done: 'Completed'
      },
      tabs: {
        details: 'Details',
        location: 'Task Location',
        assignment: 'Worker Assignment',
        files: 'Files',
        checklist: 'Checklist',
        notes: 'Notes'
      },
      details: {
        title: 'Task Details',
        description: 'Description',
        schedule: 'Schedule',
        dueDate: 'Due Date',
        payment: 'Payment Information',
        total: 'Total Payment',
        rate: 'Rate'
      },
      location: {
        title: 'Task Location',
        address: 'Address',
        city: 'City',
        state: 'State',
        zipCode: 'ZIP Code',
        country: 'Country',
        coordinates: 'Coordinates',
        zoom: 'Zoom Level',
        noLocation: 'No location information available',
        map: 'Interactive Map',
        loadingMap: 'Loading map...',
        mapInstructions: 'Click on the map to view location details',
        navigation: 'Open in Navigation Apps',
        googleMaps: 'Google Maps',
        appleMaps: 'Apple Maps',
        waze: 'Waze',
        navigationHint: 'Click any button to open the location in your preferred navigation app'
      },
      assignment: {
        title: 'Worker Assignment',
        assignedTo: 'Assigned To',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        project: 'Project',
        business: 'Business'
      },
      files: {
        title: 'Files & Documents',
        document: 'Document',
        viewDocument: 'View Document',
        noFiles: 'No files attached to this task'
      },
      checklist: {
        title: 'Task Checklist',
        noChecklist: 'No checklist available for this task',
        addNewItem: 'Add New Item',
        itemPlaceholder: 'Enter a new checklist item...',
        startAdding: 'Start adding items to track your progress'
      }
    },

    // Notifications
    notifications: {
      assignmentAccepted: 'Your offer for the task "{{taskTitle}}" has been accepted.',
      assignmentRejected: 'Your offer for the task "{{taskTitle}}" has been rejected.',
      assignmentCounter: 'You have received a counter offer for the task "{{taskTitle}}".',
      assignmentNewJob: 'You have a new job assigned! Task: "{{taskTitle}}".',
      notificationNoMessage: 'Notification without message',
      certificationApproved: 'Certification Approved',
      certificationRejected: 'Certification Rejected',
      workerApproved: 'Profile Approved',
      workerRejected: 'Profile Rejected',
      profilePhotoRejected: 'Profile Photo Rejected',
      identificationRejected: 'Identification Rejected',
      addressRejected: 'Address Rejected',
      certificationApprovedMessage: 'Your certification "{{certificationName}}" has been approved successfully.',
      certificationRejectedMessage: 'Your certification "{{certificationName}}" has been rejected. Reason: {{reason}}',
      workerApprovedMessage: 'Your worker profile has been approved. You can now receive work assignments.',
      workerRejectedMessage: 'Your worker profile has been rejected. Reason: {{reason}}',
      profilePhotoRejectedMessage: 'Your profile photo has been rejected. You will need to upload a new photo. Reason: {{reason}}',
      identificationRejectedMessage: 'Your identification has been rejected. You will need to upload new identification documents. Reason: {{reason}}',
      addressRejectedMessage: 'Your address has been rejected. You will need to provide a new address. Reason: {{reason}}',
      noReasonProvided: 'No specific reason was provided',
      reviewNotes: 'Review Notes',
      reviewNotesOptional: 'Review Notes (Optional)',
      reviewNotesRecommended: 'Review Notes (Recommended)',
      addReviewComments: 'Add review comments...',
      explainRejectionReason: 'Explain the reason for rejection...',
      cancel: 'Cancel',
      approve: 'Approve',
      reject: 'Reject',
    },

    // Menu
    menu: {
      title: 'Menu',
      close: 'Close menu',
      profile: 'Profile',
      logout: 'Logout',
      myBusiness: 'My Business',
      admin: {
        dashboard: 'Admin Dashboard',
        skills: 'Skills Management',
        userPasswords: 'Password Management'
      },
      worker: {
        dashboard: 'Worker Dashboard',
        balance: 'Balance'
      },
      employee: {
        dashboard: 'Employee Dashboard',
        tasks: 'Tasks',
        projects: 'Projects',
        timesheet: 'Timesheet'
      },
      dashboard: 'Dashboard',
      quotations: 'Quotations',
      projects: 'Projects',
      settings: 'Settings',
      workerAgenda: 'My Agenda',
      business: {
        clients: 'Clients'
      },
      businessAgenda: 'Business Agenda'
    },

    // User Blocked
    userBlocked: {
      title: 'Account Blocked',
      subtitle: 'Your account has been temporarily suspended',
      message: 'Your account has been blocked. Reason: {{reason}}',
      blockReason: 'Block reason',
      noReasonProvided: 'No specific reason was provided',
      blockedAt: 'Block date',
      blockedBy: 'Blocked by',
      administrator: 'System Administrator',
      needHelp: 'Need help?',
      contactSupport: 'If you believe this is an error or want to appeal the decision, please contact technical support.',
      thankYou: 'Thank you for your understanding'
    },

    // Admin
    admin: {
      skills: {
        title: 'Skills Management',
        categories: 'Categories',
        skills: 'Skills',
        certifications: 'Certifications',
        addCategories: 'Add Category',
        addSkills: 'Add Skill',
        addCertifications: 'Add Certification',
        nameEn: 'Name (English)',
        nameEs: 'Name (Spanish)',
        descriptionEn: 'Description (English)',
        descriptionEs: 'Description (Spanish)',
        issuerEn: 'Issuer (English)',
        issuerEs: 'Issuer (Spanish)',
        durationEn: 'Duration (English)',
        durationEs: 'Duration (Spanish)',
        construction: 'Construction',
        health: 'Health',
        category: 'Category',
        selectCategory: 'Select Category'
      },
      userPasswords: {
        title: 'User Password Management',
        searchPlaceholder: 'Search users...',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        updatePassword: 'Update Password',
        updating: 'Updating...',
        cancel: 'Cancel',
        selectUser: 'Select a user to change their password',
        loadingUsers: 'Loading users...',
        noUsers: 'No registered users',
        noResults: 'No users found',
        passwordRequired: 'New password is required',
        passwordMinLength: 'Password must be at least 6 characters long',
        passwordsDontMatch: 'Passwords do not match',
        passwordUpdated: 'Password updated successfully',
        errorUpdating: 'Error updating password',
        errorLoading: 'Error loading users',
        user: 'User',
        email: 'Email',
        role: {
          admin: 'Administrator',
          business: 'Business',
          worker: 'Worker'
        }
      },
      approvalProcess: {
        title: 'Worker Approval',
        name: 'Name',
        email: 'Email',
        createdAt: 'Registration Date',
        actions: 'Actions',
        view: 'View',
        profileReview: 'Profile Review',
        status: 'Status',
        verificationStatus: 'Verification Status',
        'verificationStatus.approved': 'User approved successfully',
        'verificationStatus.rejected': 'User rejected',
        language: 'Language',
        onBoarding: 'OnBoarding',
        address: 'Address',
        identification: 'Identification',
        type: 'Type',
        number: 'Number',
        certifications: 'Certifications',
        certification: 'Certification',
        issuer: 'Issuer',
        date: 'Date',
        viewCertificate: 'View Certificate',
        noCertifications: 'No certifications',
        experience: 'Experience',
        noSkills: 'No skills',
        approve: 'Approve',
        reject: 'Reject',
        rejectionDetails: 'Rejection Details',
        rejectProfilePhoto: 'Reject Photo',
        rejectIdentification: 'Reject ID',
        rejectAddress: 'Reject Address',
        approveAddress: 'Approve Address',
        approveIdentification: 'Approve ID',
        blockUser: 'Block User',
        unblockUser: 'Unblock User',
        tabs: {
          all: 'All',
          new: 'New',
          approved: 'Approved',
          pending: 'Pending',
          rejected: 'Rejected',
          blocked: 'Blocked',
          certificationsPending: 'Certifications Pending'
        }
      },
      businessManagement: {
        title: 'Pending Business Management',
        companyName: 'Company Name',
        businessEmail: 'Email',
        status: 'Status',
        actions: 'Actions',
        view: 'View',
        detailTitle: 'Business Details',
        approve: 'Approve',
        reject: 'Reject',
      },
      siteSettings: {
        title: 'Site Settings',
        description: 'Here you can modify the general site settings.',
        comingSoon: 'Coming soon: site configuration options.',
        statusTab: 'Site Status',
        configTab: 'Configuration',
        statusTitle: 'Site Status and Usage',
        users: 'Users',
        projects: 'Projects',
        quotations: 'Quotations'
      },
    },

    userRoles: {
      worker: 'Workers',
      admin: 'Administrators',
      business: 'Businesses',
    },

    // Business
    business: {
      information: 'Information',
      dashboard: 'Business Dashboard',
      profile: 'My Business',
      quotations: 'Quotations',
      clients: 'Clients',
      addClient: 'Add client',
      editClient: 'Edit client',
      noClients: 'No clients registered',
      contactInfo: 'Contact Information',
      additionalInfo: 'Additional Information',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      employeeCount: 'Number of Employees',
      description: 'Description',
      services: 'Services',
      serviceName: 'Service Name',
      serviceNamePlaceholder: 'Ex: Electrical installation, Plumbing, etc.',
      servicePrice: 'Price',
      servicePricePlaceholder: 'Ex: 50, 200, etc.',
      servicePriceType: 'Price Type',
      serviceDescription: 'Service Description',
      serviceDescriptionPlaceholder: 'Describe the service details...',
      noServices: 'No services registered',
      addFirstService: 'Click "Add" to add your first service',
      taxes: 'Taxes',
      taxName: 'Tax Name',
      taxNamePlaceholder: 'Ex: VAT, ISR, etc.',
      taxPercentage: 'Percentage',
      taxPercentagePlaceholder: 'Ex: 16, 8.5, etc.',
      taxDescription: 'Tax Description',
      taxDescriptionPlaceholder: 'Describe the tax details...',
      noTaxes: 'No taxes registered',
      addFirstTax: 'Click "Add" to add your first tax',
      priceTypes: {
        fixed: 'Fixed',
        hourly: 'Per Hour',
        daily: 'Per Day'
      },
      statuses: {
        pending: 'Pending',
        active: 'Active',
        inactive: 'Inactive'
      },
      recentClients: 'Recent Clients',
      recentProjects: 'Recent projects',
      noProjects: 'No projects registered',
      recentEmployees: 'Recent employees',
      financialOverview: 'Financial overview',
      income: 'Income',
      expenses: 'Expenses',
      balance: 'Balance',
      taskCompletion: 'Task completion',
      completed: 'Completed',
      of: 'of',
      tasks: 'tasks',
      noEmployees: 'No employees registered',
      badgeEmployee: 'Employee',
      badgeWorker: 'Worker',
      assignedProjects: 'Assigned Projects',
      noAssignedProjects: 'No projects assigned',
      noTaskTitle: 'Untitled task',
      taskStatusNew: 'Not started',
      taskStatusInProgress: 'In progress',
      taskStatusDone: 'Completed',
      logoUpdated: 'Logo updated successfully',
      logoUploadError: 'Error uploading logo',
      logoRemoved: 'Logo removed successfully',
      logoRemoveError: 'Error removing logo',
      removeLogo: 'Remove logo',
      generalInfo: 'General Information',
      location: 'Location',
      clientName: 'Client Name',
      clientNamePlaceholder: 'Enter name',
      clientEmail: 'Email',
      clientEmailPlaceholder: 'example@email.com',
      clientPhone: 'Phone',
      clientPhonePlaceholder: '+1234567890',
      clientAddress: 'Address',
      clientAddressPlaceholder: 'Street, city, country',
      addressHelp: 'Enter the complete client address to facilitate location and project management.',
      logoUrl: 'Logo URL',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      logoHelp: 'You can add the client logo to personalize documents and reports.',
      uploadLogo: 'Upload Logo (PNG)',
      changeLogo: 'Change Logo (PNG)',
      logoRequirements: 'Logo requirements:',
      logoFormatPng: 'Format: PNG only',
      logoMaxSize: 'Maximum size: 2MB',
      logoRecommendation: 'Recommended: Transparent background, 500x500px',
      contacts: 'Contacts',
      existingContacts: 'Registered contacts',
      addNewContact: 'Add new contact',
      addContact: 'Add contact',
      noContacts: 'No contacts registered',
      addFirstContact: 'Add the first contact above',
      contactName: 'Name',
      contactNamePlaceholder: 'Contact name',
      contactEmail: 'Email',
      contactEmailPlaceholder: 'email@example.com',
      contactPhone: 'Phone',
      contactPhonePlaceholder: '+1234567890',
      contactLinkedin: 'LinkedIn URL',
      contactDetails: 'Contact details',
      viewProfile: 'View profile',
      linkedinProfileMessage: 'Professional profile on LinkedIn',
      openLinkedIn: 'Open in LinkedIn',
      confirmDeleteContact: 'Delete this contact?',
      clientRegistered: 'client registered',
      clientsRegistered: 'clients registered',
      addFirstClientMessage: 'Start by adding your first client to manage projects and contacts',
      addFirstClient: 'Add first client',
      contact: 'contact',
      contactsPlural: 'contacts',
      addedOn: 'Added on',
      dateNotAvailable: 'Date not available',
    },

    // Errors
    errors: {
      fetchClients: 'Error loading clients',
      updateClient: 'Error updating client',
      onlyPngAllowed: 'Only PNG files are allowed',
      fileTooLarge: 'File is too large (max. 2MB)',
      logoUpload: 'Error uploading logo',
      logoRemove: 'Error removing logo',
      contactNameEmailRequired: 'Contact name and email are required',
    },

    // Common
    common: {
      loading: 'Loading...',
      saving: 'Saving...',
      uploading: 'Uploading...',
      error: 'An error occurred',
      success: 'Form submitted successfully',
      updateSuccess: 'Data updated successfully',
      addSuccess: 'Item added successfully',
      deleteSuccess: 'Item deleted successfully',
      changesSaved: 'Changes saved successfully',
      errorSaving: 'Error saving changes',
      you: 'You',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search...',
      noResults: 'No results found',
      required: 'Required',
      optional: 'Optional',
      back: 'Back',
      goBack: 'Go Back',
      next: 'Next',
      previous: 'Previous',
      change: 'Change',
      finish: 'Finish',
      submit: 'Submit',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      close: 'Close',
      open: 'Open',
      copied: 'Copied',
      copy: 'Copy',
      status: {
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        completed: 'Completed',
        cancelled: 'Cancelled',
        unread: 'Unread',
        approved: 'Approved',
        rejected: 'Rejected'
      },
      pending: 'Pending',
      select: 'Select an option',
      formNotFound: 'Form not found',
      added: 'Added',
      location: 'Location',
      skills: 'Skills',
      certifications: 'Certifications',
      actions: 'Actions',
      view: 'View',
      employee: 'Employee',
      worker: 'Worker',
      business: 'Business',
      createdAt: 'Created',
      updatedAt: 'Updated',
      accept: 'Accept',
      reject: 'Reject',
      saveAndContinue: 'Save and continue',
      viewAll: 'View all',
      certApproved: 'Certification approved',
      certRejected: 'Certification rejected',
      download: 'Download',
      retry: 'Retry',
      share: 'Share',
      showQR: 'Show QR',
      hideQR: 'Hide QR',
    },



    // Onboarding Status
    onboardingStatus: {
      completed: 'Completed',
      notStarted: 'Not started',
      inProgress: 'In progress',
      pending: 'Pending review',
      rejected: 'Rejected',
      steps: 'Steps',
      progress: 'OnBoarding Progress',
      completedSteps: 'Completed Steps',
    },



    // Onboarding
    onboarding: {
      title: 'OnBoarding',
      completed: 'OnBoarding completed!',
      identity: {
        title: 'Identity Document',
        description: 'Upload a photo of your identity document to verify your account.',
        documentType: 'Document Type',
        selectDocumentType: 'Select document type',
        dni: 'DNI',
        passport: 'Passport',
        residency: 'Residency',
        documentNumber: 'Document Number',
        documentNumberPlaceholder: 'Enter your document number',
        documentFront: 'Document Front',
        documentFrontPreviewAlt: 'Document front preview',
        documentBack: 'Document Back',
        documentBackPreviewAlt: 'Document back preview',
        driverLicense: "Driver's license"
      },
      address: {
        title: 'Address',
        description: 'Provide your residential address.',
        country: 'Country',
        selectCountry: 'Select your country',
        state: 'State/Province',
        selectState: 'Select your state',
        city: 'City',
        selectCity: 'Select your city',
        street: 'Street',
        streetPlaceholder: 'Street name',
        number: 'Number',
        numberPlaceholder: 'House/building number',
        apartment: 'Apartment/Office',
        apartmentPlaceholder: 'Apartment or office number (optional)',
        zipCode: 'Zip Code',
        zipCodePlaceholder: 'Zip code',
        additionalInfo: 'Additional Information',
        additionalInfoPlaceholder: 'References, landmarks, etc. (optional)'
      },
      skills: {
        title: 'Skills and Experience',
        description: 'Select the skills you have and your experience level.',
        errorLoading: 'Error loading skills',
        errorSaving: 'Error saving skills',
        noData: 'No skills available',
        selectedSkills: '{{count}} skills selected'
      },
      profilePhoto: {
        title: 'Profile Photo',
        description: 'Upload a professional profile photo.',
        dragAndDrop: 'Drag and drop your photo here, or click to select',
        selectPhoto: 'Select Photo',
        changePhoto: 'Change Photo',
        errorUploading: 'Error uploading photo',
        errorSaving: 'Error saving photo'
      },
      certifications: {
        title: 'Certifications',
        description: 'Add your professional certifications.',
        name: 'Certification Name',
        selectCertification: 'Select a certification',
        date: 'Obtainment Date',
        file: 'Certification File',
        fileSelected: 'File selected',
        remove: 'Remove',
        add: 'Add Certification',
        errorLoading: 'Error loading certifications',
        errorFileType: 'Please select a valid PDF file',
        errorSaving: 'Error saving certification',
        frontImage: "Front Image",
        backImage: "Back Image",
        uploadInfo: "You can upload a PDF of your certification or an image of the card. Front and back images are optional, but at least one of the three files is required.",
        noFileSelected: 'No files selected',
      },
      myCertifications: {
        title: 'My Certifications',
        addCertification: 'Add Certification',
        noCertifications: 'You have no registered certifications. Add a new certification to show your credentials!',
        addFirstCertification: 'Add my first certification',
        date: 'Date',
        uploadedAt: 'Uploaded at',
        errorLoading: 'Error loading certifications',
        startText: 'Start by adding your first certification to showcase your skills and experience.'
      },
      sector: {
        title: 'Select your sector',
        description: 'Please select the sector you want to apply for as a worker.',
        selectLabel: 'Sector',
        selectPlaceholder: 'Select a sector',
        health: 'Health',
        construction: 'Construction',
        continue: 'Continue',
        errorRequired: 'Please select a sector.',
        errorUnauthenticated: 'User not authenticated.',
        errorUnknown: 'Unknown error.'
      }
    },

    projects: {
      title: 'Projects',
      create: 'Create Project',
      searchPlaceholder: 'Search projects...',
      filter: 'Status',
      client: 'Client',
      totalAmount: 'Total Amount',
      startDate: 'Start Date',
      notStarted: 'Not Started',
      status: {
        active: 'Active',
        completed: 'Completed',
        onHold: 'On Hold',
        cancelled: 'Cancelled'
      },
      empty: 'No projects registered for this business. Create your first project by clicking "Create Project"!',
      noResults: 'No projects found',
      adjustFilters: 'Try adjusting the search filters',
      startCreating: 'Start by creating your first project',
      allStatuses: 'All statuses',
      allClients: 'All clients',
      unknownClient: 'Unknown client',
      name: 'Name',
      descriptionPlaceholder: 'Describe the project...',
      selectClient: 'Select client',
      endDate: 'End Date',
      created: 'Project created successfully',
      validation: {
        required: 'Please complete all required fields'
      },
      pagination: {
        prev: 'Previous',
        next: 'Next',
        page: 'Page',
        of: 'of'
      },
      progress: 'Progress',
      createdOn: 'Created on',
      projectRegistered: 'project registered',
      projectsRegistered: 'projects registered',
      startCreatingMessage: 'Start by creating your first project to manage tasks and resources',
      createFirst: 'Create first project',
      viewTitle: 'Project Details',
      viewIdLabel: 'Project UID',
      notFound: 'Project not found',
      info: {
        name: 'Name',
        services: 'Services',
        quotation: 'Quotation',
        status: 'Status',
        amount: 'Amount',
        startDate: 'Start Date',
        endDate: 'End Date',
        progress: 'Progress',
        description: 'Description',
        createdAt: 'Created at',
        viewHistory: 'View history',
      },
      tabs: {
        info: 'Info',
        client: 'Client',
        tasks: 'Tasks',
        staff: 'Staff',
        documents: 'Documents',
        materials: 'Materials',
        finances: 'Finances',
        services: 'Services',
        addStaff: 'Add Staff',
        noStaff: 'No staff assigned yet',
        addStaffDescription: 'Add workers or employees to this project',
        filterRole: 'All Roles',
        filterSkill: 'Filter by skill',
        filterCert: 'Filter by certification',
        filterCity: 'Filter by city',
        assignWorker: 'Assign Worker'
      },
      staff: {
        addSelf: 'Add Me to Team',
        addSelfTitle: 'Add Me to Project Team',
        addSelfDescription: 'Select your role in this project:',
        addSelfButton: 'Add Me to Team',
        selfAdded: 'You have been successfully added to the project team',
        alreadyAdded: 'You are already added to the project team',
        errorAddingSelf: 'Error adding yourself to the team',
        projectManagerDesc: 'Manages and oversees the entire project',
        supervisorDesc: 'Supervises field work and quality',
        editRole: 'Edit role',
        assignRole: 'Assign role',
        editRoleTitle: 'Assign role in project',
        member: 'Member',
        selectRole: 'Select the role in this project:',
        updateRole: 'Update role',
        roleUpdated: 'Role updated successfully',
        errorUpdatingRole: 'Error updating role',
        remove: 'Remove from team',
        confirmRemove: 'Are you sure you want to remove this member from the team?',
        memberRemoved: 'Member removed from team',
        errorRemoving: 'Error removing member',
        noRole: 'No specific role',
        noRoleDesc: 'Team member without defined role',
        tasksAssigned: 'tasks assigned',
        memberDetails: 'Member Details',
        memberDetailsDesc: 'Information and permissions of team member',
        memberInfo: 'Member Information',
        skills: 'Skills',
        projectRole: 'Role in Project',
        projectRoleDesc: 'Define the specific function of this member in the project',
        signaturePermission: 'Signature Permission',
        signaturePermissionDesc: 'Allow this member to sign scanning job reports on your behalf',
        canSignForMe: 'Can sign for me',
        canSignForMeDesc: 'This user can sign scanning reports on your behalf when necessary',
        memberUpdated: 'Member updated successfully',
        errorUpdating: 'Error updating member',
        othersWhoGrantedPermission: 'Other users who have granted permission'
      },
      statusLabel: 'Status',
      descriptionLabel: 'Description',
      kanban: {
        new: 'New',
        inProgress: 'In progress',
        done: 'Completed',
        createTask: 'Create Task',
        editTask: 'Edit Task',
        taskTitle: 'Title',
        taskDescription: 'Description',
        startDate: 'Start Date',
        startTime: 'Start Time',
        duration: 'Duration',
        durationUnit: 'Unit',
        days: 'Days',
        hours: 'Hours',
        status: 'Status',
        progress: '% Completed',
        details: 'Details',
        location: 'Location',
        lat: 'Lat',
        lng: 'Lng',
        dropHere: 'Drop here',
        tabs: {
          general: 'General',
          assignment: 'Assignment',
          location: 'Location',
          documents: 'Documents',
          files: 'Files'
        },
        checklist: {
          title: 'Checklist',
          enable: 'Enable checklist',
          disable: 'Disable checklist',
          addItem: 'Add item',
          itemPlaceholder: 'New checklist item...',
          completed: 'Completed',
          pending: 'Pending',
          progress: 'Automatic progress based on checklist',
          noItems: 'No items in checklist',
          more: 'more',
          disabled: 'Checklist is disabled',
          progressDescription: 'Progress is automatically calculated based on completed items'
        },
        newColumn: 'New Column',
        addColumn: 'Add Column',
        uploadFiles: 'Upload files',
        dragAndDrop: 'Drag and drop files here, or click to select',
        supportedFormats: 'Supported formats: Images, PDF, DOC, XLS',
        maxFileSize: 'Max file size: 10MB',
        noFiles: 'No files uploaded',
        deleteFile: 'Delete file',
        downloadFile: 'Download file',
        fileUploaded: 'File uploaded successfully',
        fileDeleted: 'File deleted successfully',
        uploadError: 'Error uploading file',
        deleteError: 'Error deleting file',
        uploadingFiles: 'Uploading files...',
        scanningJob: {
          title: 'Is a Scanning Job?',
          description: 'Enable this option if this task includes concrete scanning work',
          purpose: 'Purpose',
          equipment: 'Equipment',
          process: 'Process',
          limitations: 'Limitations',
          findings: 'Findings',
          closure: 'Closure',
          report: 'Scanning Job Report',
          generateReport: 'Generate Report',
          checklist: {
            structuralReinforcement: {
              title: 'A. Structural Reinforcement',
              rebarDetected: 'Rebar detected',
              wireMeshDetected: 'Wire mesh detected',
              postTensionTendons: 'Post-tension tendons detected',
              noReinforcement: 'No reinforcement detected in the scanned area'
            },
            detectedUtilities: {
              title: 'B. Detected Utilities',
              electricalConduit: 'Electrical conduit',
              communicationsConduit: 'Communications conduit',
              metalPipe: 'Metal pipe',
              pvcPipe: 'PVC pipe',
              energizedUtilities: 'Energized utilities detected (EM readings)',
              noUtilities: 'No utilities detected'
            },
            slabConditions: {
              title: 'C. Slab Conditions',
              highMoisture: 'High moisture levels in slab',
              interference: 'Interference in signals',
              limitedDepth: 'Limited depth penetration',
              irregularSurface: 'Irregular surface affected scanning'
            },
            surfaceMarkings: {
              title: 'D. Surface Markings',
              markedRed: 'Marked in red (electrical)',
              markedYellow: 'Marked in yellow (reinforcement)',
              highRiskAreas: 'High-risk areas marked',
              manualExposure: 'Manual exposure required before drilling/cutting'
            },
            recommendations: {
              title: 'E. Recommendations',
              avoidDrilling: 'Avoid drilling near marked areas',
              manuallyExpose: 'Manually expose marked items before cutting',
              reviewDrawings: 'Review structural drawings',
              recommendRescan: 'Recommend re-scan due to interference'
            }
          }
        }
      },
      assignment: {
        worker: 'Worker',
        amount: 'Amount',
        total: 'Total',
        status: 'Status',
        statuses: {
          pending: 'Pending',
          accepted: 'Accepted',
          rejected: 'Rejected',
          counter: 'Counteroffer',
          removed: 'Removed'
        },
        startDate: 'Start date',
        duration: 'Duration',
        perHour: 'per hour',
        perDay: 'per day',
        hours: 'hours',
        days: 'days',
        location: 'Location',
        counter: 'Counteroffer',
        noRequests: 'You have no pending assignment requests.',
        requestDetails: 'Request Details',
        workerInfo: 'Worker Information',
        offerDetails: 'Offer Details',
        price: 'Price',
        workerCounteroffer: 'Worker Counteroffer',
        accept: 'Accept',
        reject: 'Reject',
        sending: 'Sending...',
        sendCounteroffer: 'Send Counteroffer',
        viewDetails: 'View details',
        title: 'Assignment Requests',
        distance: '{{distance}} km away',
        feeLabel: 'Service fee',
        fee: 'fee',
        netLabel: 'Net to receive',
        feeInfo: 'How our costs work',
        counterLabel: 'Your counteroffer',
        totalLabel: 'Total',
        feeLabelShort: 'Service fee',
        netLabelShort: 'Net to receive',
        feeInfoShort: 'How our costs work',
      },
      workerAssignment: {
        title: 'Worker assignment',
        searchPlaceholder: 'Search by name, email, city or skill...',
        skills: 'Skills',
        certifications: 'Certifications',
        noWorkers: 'No active workers available.',
        offerButton: 'Offer',
        offerTitle: 'Offer to {{name}}',
        price: 'Offered price',
        unit: 'Unit',
        selectUnit: 'Select unit',
        hour: 'Hour',
        day: 'Day',
        duration: 'Duration',
        sendOffer: 'Send offer',
        offerSent: 'Offer sent successfully',
        offerError: 'Error sending offer',
        completeAllFields: 'Please complete all fields',
        workerAssigned: 'Worker successfully assigned to the task',
        assignmentRequests: 'Assignment requests',
        sendMoreOffers: 'Send more offers',
        viewHistory: 'View history',
        currentlyAssigned: 'Currently assigned workers',
        assignNewWorker: 'Assign New Worker',
        workersAlreadyAssigned: 'You already have workers assigned to this task',
        removeWorkerToAssign: 'Remove a worker to assign a new one',
      },
      deleteTask: {
        cannotDelete: 'You cannot delete this task',
        hasWorkerAssigned: 'This task has a contracted worker.',
        workerProtection: 'To protect the worker\'s rights, you cannot delete a task that has already been accepted.',
        removeWorkerFirst: 'You must first remove the assigned worker or cancel the assignment.',
        understood: 'Understood'
      },
      history: {
        title: 'Project History',
        project: 'Project',
        export: 'Export CSV',
        filter: 'Filter by action',
        all: 'All',
        records: 'Records',
        project_updated: 'Project updated',
        project_created: 'Project created',
        project_upload: 'Project upload',
        task_created: 'Task created',
        task_deleted: 'Task deleted',
        task_updated: 'Task updated',
        worker_assigned: 'Worker assigned',
        worker_removed: 'Worker removed',
        offer_sent: 'Offer sent',
        offer_accepted: 'Offer accepted',
        offer_rejected: 'Offer rejected',
        counter_offer: 'Counter offer',
        location_updated: 'Location updated',
        checklist_updated: 'Checklist updated',
        details_updated: 'Details updated',
        worker_updated: 'Worker updated',
        performedBy: 'Performed by',
        documentsChanged: 'Documents changed',
        materialChanged: 'Material changed',
        fieldChanged: 'Field changed',
        newValue: 'New value',
        noHistory: 'No history',
        noHistoryMessage: 'No activity records were found for this project.',
        loadingHistory: 'Loading history...',
        errorMissingData: 'Missing user or project data',
        changeDetails: 'Change details',
        changes: 'Changes made',
        summary: {
          project_created: 'Project created',
          document_uploaded: 'Document uploaded',
          material_added: 'Material added',
          material_deleted: 'Material deleted',
          material_edited: 'Material edited',
          name_changed: 'Project name changed',
          description_changed: 'Description changed',
          client_changed: 'Client changed',
          columns_changed: 'Columns changed',
          document_deleted: 'Document deleted',
          project_updated: 'Project updated',
          task_created: 'Task created',
          task_deleted: 'Task deleted',
          worker_assigned: 'Worker assigned',
          worker_removed: 'Worker removed',
          task_updated: 'Task updated',
          offer_sent: 'Offer sent',
          offer_accepted: 'Offer accepted',
          offer_rejected: 'Offer rejected',
          counter_offer: 'Counter offer',
          location_updated: 'Location updated',
          checklist_updated: 'Checklist updated',
          details_updated: 'Details updated',
          worker_updated: 'Worker updated',
          generic: 'Project activity',
        }
      },
      materials: {
        title: 'Project Materials',
        name: 'Name',
        description: 'Description',
        quantity: 'Quantity',
        unit: 'Unit',
        price: 'Price',
        add: 'Add',
        delete: 'Delete',
        edit: 'Edit',
        noMaterials: 'No materials',
        history: 'Materials History',
        addMaterialsNeeded: 'Add necessary materials for this project',
        materialsHistoryInDevelopment: 'Materials change history (feature in development)',
        origin: 'Origin',
        actions: 'Actions',
        taskFiles: 'Task Files',
        added: 'Added',
        quotation: 'Quotation',
        noData: 'No materials found.',
      },
      documents: {
        title: 'Project Documents',
        upload: 'Upload Document',
        view: 'View',
        delete: 'Delete',
        noDocuments: 'No documents',
        uploadDocument: 'Upload document',
        dragAndDrop: 'Drag and drop documents here, or click to select',
        supportedFormats: 'Supported formats: PDF, DOC, XLS, images',
        maxFileSize: 'Maximum size: 10MB',
        uploading: 'Uploading...',
        uploadSuccess: 'Document uploaded successfully',
        uploadError: 'Error uploading document',
        deleteSuccess: 'Document deleted successfully',
        deleteError: 'Error deleting document',
        download: "Download",
      },
      services: {
        title: 'Project Services',
        name: 'Name',
        description: 'Description',
        duration: 'Duration',
        price: 'Price',
        add: 'Add Service',
        delete: 'Delete',
        edit: 'Edit',
        noServices: 'No services',
        history: 'History',
        addServicesNeeded: 'Add necessary services for this project',
        origin: 'Origin',
        actions: 'Actions',
        added: 'Added',
        quotation: 'Quotation',
        hours: 'hours',
        days: 'days',
        perHour: '/hour',
        perDay: '/day',
        total: 'Total'
      },
      finances: {
        title: 'Project Finances',
        summary: 'Financial Summary',
        income: 'Income',
        expenses: 'Expenses',
        profit: 'Profit',
        budget: 'Budget',
        actual: 'Actual',
        variance: 'Variance',
        revenue: 'Revenue',
        costs: 'Costs',
        materials: 'Materials',
        services: 'Services',
        labor: 'Labor',
        overhead: 'Overhead',
        other: 'Other',
        totalRevenue: 'Total Revenue',
        totalExpenses: 'Total Expenses',
        netProfit: 'Net Profit',
        profitMargin: 'Profit Margin',
        budgetOverview: 'Budget Overview',
        expenseBreakdown: 'Expense Breakdown',
        revenueSources: 'Revenue Sources',
        addExpense: 'Add Expense',
        addRevenue: 'Add Revenue',
        addIncome: 'Add Income',
        editTransaction: 'Edit Transaction',
        deleteTransaction: 'Delete Transaction',
        date: 'Date',
        description: 'Description',
        amount: 'Amount',
        category: 'Category',
        type: 'Type',
        status: {
          title: 'Status',
          pending: 'Pending',
          paid: 'Paid',
          cancelled: 'Cancelled'
        },
        actions: 'Actions',
        noTransactions: 'No transactions found',
        noData: 'No financial data available',
        loading: 'Loading financial data...',
        error: 'Error loading financial data',
        transactions: 'Financial Transactions',
        noTransactionsYet: 'No transactions yet',
        startTracking: 'Start adding income and expenses to track project finances',
        createSampleTransaction: 'Create Sample Transaction',
        edit: 'Edit',
        delete: 'Delete',
        expense: 'Expense',
        taxes: 'Taxes',
        transactionType: 'Transaction Type',
        payment: 'Payment',
        refund: 'Refund',
        total: 'Total',
        markAsPaid: 'Mark as Paid',
        viewReceipt: 'View Receipt',
        markAsPaidModal: {
          title: 'Mark as Paid',
          transaction: 'Transaction',
          amount: 'Amount',
          attachReceipt: 'Attach receipt (PDF or image)',
          cancel: 'Cancel',
          confirm: 'Confirm Payment',
          saving: 'Saving...',
          processing: 'Processing...'
        }
      },
      location: {
        title: 'Task location',
        map: 'Location on the map',
        latitude: 'Latitude',
        longitude: 'Longitude',
        zoom: 'Zoom',
        address: 'Address',
        city: 'City',
        state: 'State/Province',
        country: 'Country',
        zipCode: 'Postal Code',
      },
      notes: {
        title: 'Project Notes',
        writeNote: 'Write a note...',
        placeholder: 'Write a note...',
        addNote: 'Add Note',
        saving: 'Saving...',
        noNotes: 'No notes yet.',
      },
      sidebar: {
        project: 'Project',
      },
    },

    // Admin Dashboard
    adminDashboard: {
      welcome: 'Welcome, {{name}}',
      totalUsers: 'Total Users',
      activeUsers: 'Active Users',
      pendingUsers: 'Pending Users',
      userRoles: 'User Roles',
    },

    balance: {
      paymentTab: 'My payment data',
      movementsTab: 'Transactions',
      cashToggle: 'Allow cash payment?',
      allowCash: 'Allow cash payment?',
      enabled: 'Enabled',
      disabled: 'Disabled',
      addData: 'Add data',
      savedDataFor: 'Saved data for {{method}}',
      noData: 'No data saved.',
      checkName: 'Name for the check',
      paypalEmail: 'Paypal email',
      bank: 'Bank',
      account: 'CLABE or account number',
      holder: 'Account holder',
      cash: 'Cash',
      check: 'Check',
      paypal: 'Paypal',
      bank_transfer: 'Bank transfer',
      saved: 'Saved',
      saveError: 'Error saving',
      successSave: 'Data saved successfully',
      errorSave: 'Error saving data',
      savedFor: 'Saved data for {{method}}',
      loading: 'Loading...',
      errorLoading: 'Error loading data',
      title: 'Balance',
      noTransactions: 'No transactions',
      startDate: 'Start date',
      endDate: 'End date',
      allTab: 'All',
      pendingTab: 'Pending',
      paidTab: 'Paid',
      withdrawalTab: 'Withdrawals',
    },

    // --- Traducciones directas para sección de Información del Trabajo (tab proposal) ---
    proposal: {
      workInfo: 'Work Information',
      workDuration: 'Work Duration',
      workStartDate: 'Start Date',
      quotationValidityDate: 'Quotation Validity Date',
      days: 'Days',
      hours: 'Hours',
      costSummary: 'Cost Summary',
      subtotal: 'Subtotal',
      subtotalWithDiscounts: 'Subtotal with Discounts',
      total: 'Total',
      taxes: 'Taxes',
      discounts: 'Discounts',
      generatePDF: 'Generate PDF',
      saveProposal: 'Save Proposal',
      errorGeneratingPDF: 'Error generating PDF',
      pdfGenerated: 'PDF generated and saved successfully',
      pdfErrorData: 'Could not generate PDF due to incomplete data',
      viewPDF: 'View PDF',
    },
    workerProjects: {
      title: 'My Projects',
      description: 'Projects you are participating in as a worker',
      backToDashboard: 'Back to Dashboard',
      totalProjects: 'Total Projects',
      totalTasks: 'Total Tasks',
      totalEarnings: 'Total Earnings',
      averageProgress: 'Average Progress',
      myTasks: 'My Tasks',
      myPayment: 'My Payment',
      myProgress: 'My Progress',
      myTasksInProject: 'My Tasks in this Project',
      seeFullDetails: 'See Full Details',
      status: {
        active: 'Active',
        completed: 'Completed',
        pending: 'Pending'
      },
      taskStatus: {
        new: 'New',
        inProgress: 'In Progress',
        done: 'Completed'
      },
      startDate: 'Start Date',
      endDate: 'End Date',
    },
    welcome: {
      title: 'Meet your NEW & IMPROVED project platform',
      subtitle: 'Connect talent and opportunities in one place.',
      login: 'Log In',
      register: 'Register',
      chooseType: 'How do you want to register?',
      asWorker: 'As Worker',
      asEmployee: 'As Employee',
      asBusiness: 'As Business',
      chooseSector: 'Which sector is your company in?',
      sectorHealth: 'Health Sector',
      sectorConstruction: 'Construction Sector',
      carousel: {
        feature1: 'Manage your projects from start to finish',
        feature2: 'Find and connect with qualified talent',
        feature3: 'Easily upload and validate your certifications',
        feature4: 'Modern, fast and accessible navigation',
      },
      close: 'Close',
    },
    auth: {
      businessRegister: 'Business Registration',
      healthBusinessRegister: 'Health Business Registration',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      yourName: 'Your name',
      yourLastName: 'Your last name',
      yourEmail: 'your@email.com',
      passwordPlaceholder: '••••••••',
      ruc: 'RUC',
      rimpe: 'RIMPE',
      ein: 'EIN',
      duns: 'DUNS',
      sa: 'Corporation (SA)',
      ltda: 'Limited Company (LTDA)',
      consorcio: 'Consortium',
      sas: 'Simplified Stock Company (SAS)',
      llc: 'LLC',
      inc: 'Inc.',
      corp: 'Corporation',
      clickToSelectLogo: 'Click to select your logo',
      alreadyHaveAccount: "Already have an account?",
      login: "Login",
      allFieldsRequired: 'All fields are required',
      logoRequired: 'Logo is required',
      passwordsDoNotMatch: 'Passwords do not match',
      registrationSuccess: 'Registration successful! Welcome!',
      registrationError: 'There was an error during registration',
      selectCountry: 'Select country',
      selectBusinessIdType: 'Select business ID type',
      selectCompanyType: 'Select company type',
      uploadLogo: 'Upload your company logo',
      registering: 'Registering...',
      register: 'Register',
      country: 'Country',
      businessIdType: 'Business ID Type',
      businessId: 'Business ID',
      companyName: 'Company Name',
      companyType: 'Company Type',
      address: 'Address',
      phone: 'Phone',
      businessEmail: 'Business Email',
      employeeCount: 'Number of Employees',
      logo: 'Logo',
      ecuador: 'Ecuador',
      unitedStates: 'United States',
      logoUploaded: 'Logo uploaded',
      selectFile: 'Select file',
    },
    quotations: {
      title: 'Quotations',
      add: 'Add Quotation',
      edit: 'Edit Quotation',
      create: 'Create Quotation',
      update: 'Update Quotation',
      editForm: 'Edit Form',
      description: 'Description',
      terms: 'Terms',
      deliveryTime: 'Delivery Time',
      paymentTerms: 'Payment Terms',
      notes: 'Notes',
      updateForm: 'Update Form',
      client: 'Client',
      projectName: 'Project Name',
      amount: 'Amount',
      currency: 'Currency',
      statusLabel: 'Status',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      sentQuotations: 'Sent Quotations',
      noQuotations: 'No quotations available',
      noSentQuotations: 'No sent quotations',
      field1: 'Field 1',
      field2: 'Field 2',
      noDate: 'No date available',
      statusOptions: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        unread: 'Unread',
        read: 'Read',
        converted: 'Converted to Project'
      },
      formBuilder: {
        title: 'Customize Form',
        subtitle: 'Fill out the form to request a new quotation',
        clientInfo: 'Client Information',
        basicClientInfo: 'Basic client information',
        clientName: 'Name',
        clientEmail: 'Email',
        clientPhone: 'Phone',
        clientAddress: 'Address',
        clientSince: 'Client Since',
        addStep: 'Add Step',
        stepTitle: 'Step Title',
        stepDescription: 'Step Description',
        addField: 'Add Field',
        fieldLabel: 'Field Label',
        required: 'Required',
        fieldTypes: {
          text: 'Text',
          number: 'Number',
          select: 'Select',
          multiselect: 'Multi-select',
          textarea: 'Textarea',
          date: 'Date'
        },
        save: 'Save',
        steps: 'Steps',
        fields: 'Fields',
        moveUp: 'Move up',
        moveDown: 'Move down',
        remove: 'Remove',
        formLink: 'Form Link',
        formLinkDescription: 'Share this link with your clients so they can fill out the quotation form.',
        copy: 'Copy link',
        copied: 'Link copied!',
        copyEmbed: 'Copy WordPress embed',
        defaultFields: {
          clientName: 'Name',
          clientNamePlaceholder: 'Enter client name',
          clientEmail: 'Email',
          clientEmailPlaceholder: 'Enter client email'
        },
        defaultStep: 'Basic Information',
        defaultStepDescription: 'Fill in the client basic data.'
      },
      sentQuotationsTable: 'Sent Quotations',
      requestsTable: 'Quotation Requests',
      addQuotation: 'New Quotation',
      quotationRegistered: 'quotation registered',
      quotationsRegistered: 'quotations registered',
      filterByStatus: 'Filter by status',
      showing: 'Showing',
      quotation: 'quotation',
      quotations: 'quotations',
      withStatus: 'with status',
      noClient: 'No client',
      createdBy: 'Created by',
      system: 'System',
      actions: 'Actions',
      view: 'View',
      assign: 'Assign',
      assignQuotation: 'Assign Quotation',
      selectEmployeeToAssign: 'Select an employee to assign this quotation:',
      employee: 'Employee',
      selectEmployee: 'Select an employee',
      assignedSuccess: 'Quotation assigned successfully',
      assignedTo: 'Assigned to',
      notAssigned: 'Not assigned',
      startCreatingMessage: 'Start by creating your first quotation',
      createFirst: 'Create first quotation',
      viewLog: 'View Log',
      activityLog: 'Activity Log',
      noActivityYet: 'No activity recorded yet',
      actionCreated: 'Created',
      actionAssigned: 'Assigned',
      actionRead: 'Read',
      actionSent: 'Sent',
      actionConverted: 'Converted',
      detailCreated: 'Quotation created as draft',
      detailAssigned: 'Assigned to {{employeeName}}',
      detailRead: 'Quotation opened and marked as read',
      detailSent: 'Quotation marked as sent to client',
      detailConverted: 'Quotation converted to project',
      draftCreated: 'Draft created. Select a client to continue.',
      proposal: {
        title: 'Proposal',
        services: 'Services',
        materials: 'Materials',
        taxes: 'Taxes',
        discounts: 'Discounts',
        workInfo: 'Work Information',
        costSummary: 'Cost Summary',
        noServices: 'No services specified',
        noMaterials: 'No materials specified',
        noTaxes: 'No taxes configured in the business',
        discountAmount: 'Discount Amount ($)',
        discountPercentage: 'Discount Percentage (%)',
        workDuration: 'Work Duration',
        workStartDate: 'Start Date',
        quotationValidityDate: 'Quotation Validity Date',
        days: 'Days',
        hours: 'Hours',
        subtotal: 'Subtotal',
        subtotalWithDiscounts: 'Subtotal with Discounts',
        total: 'Total',
        saveProposal: 'Save Proposal',
        generatePDF: 'Generate PDF',
        saving: 'Saving...',
        proposalSaved: 'Proposal saved successfully',
        errorSaving: 'Error saving proposal',
        errorGeneratingPDF: 'Error generating PDF',
        unitPrice: 'Unit Price',
        description: 'Description',
        pdfGenerated: 'PDF generated and saved successfully',
        pdfErrorData: 'Could not generate PDF due to incomplete data',
        viewPDF: 'View PDF',
      },
      noName: 'No name',
      noEmail: 'No email',
      selectClient: 'Select Client',
      searchClient: 'Search client...',
      createNewClient: 'Create new client',
      noClientsRegistered: 'No registered clients.',
      loadingClientData: 'Loading client data...'
    },
    taskHistory: {
      title: 'Task History',
      task: 'Task',
      filterByAction: 'Filter by action:',
      all: 'All',
      offer_sent: 'Offer sent',
      offer_accepted: 'Offer accepted',
      offer_rejected: 'Offer rejected',
      counter_offer: 'Counter offer',
      worker_removed: 'Worker removed',
      worker_negotiation: 'Negotiation',
      records: 'Records',
      performedBy: 'Performed by:',
      noHistory: 'No history found for this task.',
      task_created: 'Task created',
    },
    workerAgenda: {
      title: 'My Agenda',
      description: 'Here you can see your scheduled events, tasks, and appointments. Soon you will be able to manage your calendar from this screen.',
      placeholder: 'Coming soon: calendar and events view',
      menu: 'My Agenda',
      today: 'Today',
      previous: 'Previous',
      next: 'Next',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      weekOf: 'Week of',
      sunday: 'Sun',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      addEvent: 'Add Event',
      eventTitle: 'Title',
      eventTitlePlaceholder: 'Event title',
      eventDescription: 'Description',
      eventDescriptionPlaceholder: 'Event description',
      eventHour: 'Hour',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      eventCategory: 'Category',
      categoryRed: 'Red',
      categoryBlue: 'Blue',
      categoryGreen: 'Green',
      categoryYellow: 'Yellow',
      categoryPurple: 'Purple',
      eventStart: 'Start',
      eventEnd: 'End',
      allDay: 'All day',
      invalidDateRange: 'End date must be after start date',
      editEvent: 'Edit Event',
      delete: 'Delete',
      eventLocation: 'Location',
      eventLocationPlaceholder: 'E.g. Office, Zoom, etc.',
    },

    // Thank You Page
    thankYou: {
      title: 'Thank you for your request!',
      message: 'We have received your quotation request. Our team will review it and contact you soon with the details.'
    },

    // Error messages
    error: {
      submittingForm: 'Error submitting the form. Please try again.'
    },

    // Dynamic Code Test Page
    dynamicCodeTest: {
      title: 'Dynamic Code Scanner Test',
      subtitle: 'Test the dynamic code scanning functionality',
      scanner: 'Code Scanner',
      startCamera: 'Start Camera',
      starting: 'Starting Camera...',
      stopCamera: 'Stop Camera',
      scanning: 'Scanning...',
      capture: 'Capture & Process',
      processing: 'Processing...',
      manualEntry: 'Manual Code Entry',
      enterCode: 'Enter code manually...',
      submit: 'Submit',
      results: 'Scan Results',
      processingCode: 'Processing code...',
      employeeFound: 'Employee Found!',
      scannedAt: 'Scanned at:',
      employeeInfo: 'Employee Information',
      name: 'Name:',
      email: 'Email:',
      userId: 'User ID:',
      scannedCode: 'Scanned Code:',
      assignEmployee: 'Assign Employee',
      clearResults: 'Clear Results',
      noResults: 'No scan results yet.',
      scanInstructions: 'Start the camera and scan a dynamic code to see results.'
    },

    // Profile Page
    profile: {
      title: 'My Profile',
      personalInfo: 'Personal Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      street: 'Street',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      country: 'Country',
      experience: 'Experience',
      yearsExperience: 'Years of Experience',
      years: 'years',
      description: 'Description',
      certifications: 'Certifications',
      addCertification: 'Add Certification',
      newCertification: 'New Certification',
      certificationName: 'Certification Name',
      issuer: 'Issuer',
      issueDate: 'Issue Date',
      expiryDate: 'Expiry Date',
      certificationFile: 'Certification File',
      certificationStatus: {
        approved: 'Approved',
        rejected: 'Rejected',
        pending: 'Pending'
      },
      statistics: 'Statistics',
      totalEarnings: 'Total Earnings',
      completedJobs: 'Completed Jobs',
      rating: 'Rating',
      availableFunds: 'Available Funds',
      qrCode: 'QR Code',
      uploadingPhoto: 'Uploading photo...',
      sectors: {
        health: 'Health',
        construction: 'Construction'
      },
      status: {
        active: 'Active',
        pending: 'Pending'
      },
      error: {
        loading: 'Error loading profile',
        updating: 'Error updating profile',
        photoUpload: 'Error uploading photo',
        certificationUpload: 'Error uploading certification',
        certificationDelete: 'Error deleting certification',
        notFound: 'Profile not found',
        pdfGeneration: 'Error generating PDF',
        windowOpen: 'Could not open public profile window'
      },
      success: {
        updated: 'Profile updated successfully',
        photoUpdated: 'Photo updated successfully',
        certificationAdded: 'Certification added successfully',
        certificationDeleted: 'Certification deleted successfully',
        pdfGenerated: 'PDF generated successfully'
      },
      identification: 'Identification',
      idType: 'ID Type',
      idNumber: 'ID Number',
      frontImage: 'Front Image',
      backImage: 'Back Image',
      verificationStatus: 'Verification Status',
      noIdentification: 'No identification information',
      driverLicense: 'Driver License',
      passport: 'Passport',
      nationalId: 'National ID',
            other: 'Other',
      personalDescription: 'Personal Description',
      personalDescriptionPlaceholder: 'Tell us about yourself, your interests, experience...',
                                viewPDF: 'View PDF',
      viewPublicProfile: 'View Public Profile',
      download: 'Download',
      retry: 'Retry',
      publicLink: {
        title: 'Public Profile Link',
        scanQR: 'Scan to view profile',
        info: 'Public link information',
        noAuth: 'No authentication required to view',
        viewable: 'Anyone can view the profile',
        shareable: 'Can be shared freely'
      },
      digitalSignature: {
        title: 'Digital Signature Certificate (.p12)',
        uploaded: 'Uploaded',
        status: {
          active: 'Active',
          expired: 'Expired',
          revoked: 'Revoked'
        },
        download: 'Download certificate',
        delete: 'Delete certificate',
        noCertificate: 'No digital signature certificate uploaded',
        uploadDescription: 'Upload your .p12 certificate to sign documents digitally',
        uploadButton: 'Upload .p12 Certificate',
        infoTitle: 'About .p12 certificates',
        info1: 'The .p12 file is your personal digital signature certificate',
        info2: 'This certificate allows you to sign documents digitally',
        info3: 'Keep your certificate secure and don\'t share it',
        info4: 'The certificate is stored securely and encrypted',
        errorInvalidFile: 'Please select a valid .p12 or .pfx file',
        uploadSuccess: 'Digital signature certificate uploaded and validated successfully',
        uploadError: 'Error uploading digital signature certificate',
        confirmDelete: 'Are you sure you want to delete the digital signature certificate?',
        deleteSuccess: 'Certificate deleted successfully',
        deleteError: 'Error deleting certificate',
        errorInvalidFormat: 'Invalid certificate format',
        errorInvalidPassword: 'Incorrect password. Please try again.',
        errorNoCertificate: 'No certificate found in the file',
        errorExpired: 'This certificate has expired and cannot be used',
        errorNotYetValid: 'This certificate is not yet valid',
        passwordModal: {
          title: 'Certificate Password',
          description: 'Enter the password to validate and import your certificate',
          password: 'Password',
          passwordPlaceholder: 'Enter certificate password',
          validate: 'Validate',
          validating: 'Validating...'
        },
        certInfo: {
          subject: 'Subject',
          organization: 'Organization',
          issuer: 'Issuer',
          validity: 'Validity',
          serial: 'Serial Number'
        }
      }
    },

    // Public Profile Page
    publicProfile: {
      title: 'Public Profile',
      publicView: 'Public View',
      showContactInfo: 'Show Contact Information',
      experience: 'Experience',
      certifications: 'Certifications',
      skills: 'Skills',
      completedJobs: 'Completed Jobs',
      rating: 'Rating',
      reviews: 'Reviews',
      yearsExperience: 'Years of Experience',
      totalEarnings: 'Total Earnings',
      verified: 'Verified',
      certified: 'Certified',
      noCertifications: 'No approved certifications',
      noSkills: 'No skills registered',
      searchSkills: 'Search skills...',
      allCategories: 'All categories',
      allLevels: 'All levels',
      issuer: 'Issuer',
      issueDate: 'Issue Date',
      expiryDate: 'Expiry Date',
      roles: {
        worker: 'Worker',
        premiumWorker: 'Premium Worker',
        specialWorker: 'Special Worker'
      },
      status: {
        active: 'Active',
        pending: 'Pending'
      },
      error: {
        notFound: 'Profile not found',
        loading: 'Error loading profile'
      }
    },

    // Job History Page
    jobHistory: {
      title: 'Job History',
      currentMonth: {
        title: 'Current Month',
        jobs: 'jobs'
      },
      bestMonth: {
        title: 'Best Month',
        jobs: 'jobs'
      },
      filters: 'Filters',
      filterStatus: 'Status',
      filterDateRange: 'Date Range',
      filterBusiness: 'Business',
      filterMinAmount: 'Minimum Amount',
      filterMaxAmount: 'Maximum Amount',
      dateRange: {
        week: 'Last Week',
        month: 'Last Month',
        quarter: 'Last Quarter',
        year: 'Last Year'
      },
      status: {
        completed: 'Completed',
        cancelled: 'Cancelled',
        inProgress: 'In Progress'
      },
      stats: {
        totalJobs: 'Total Jobs',
        totalEarnings: 'Total Earnings',
        averageJobValue: 'Average Job Value',
        completionRate: 'Completion Rate'
      },
      jobsList: 'Jobs List',
      noJobs: 'No completed jobs',
      duration: 'Duration',
      rate: 'Rate',
      earnings: 'Earnings',
      units: {
        hours: 'hours',
        days: 'days'
      },
      per: {
        hour: '/hour',
        day: '/day'
      },
      error: {
        loading: 'Error loading job history'
      }
    },

    // Settings Page
    settings: {
      title: 'Settings',
      tabs: {
        profile: 'Profile',
        notifications: 'Notifications',
        privacy: 'Privacy',
        work: 'Work',
        app: 'App',
        security: 'Security'
      },
      profile: {
        title: 'Profile Information',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        language: 'Language',
        changePassword: 'Change Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        updatePassword: 'Update Password'
      },
      notifications: {
        title: 'Notification Settings',
        email: 'Email Notifications',
        emailDescription: 'Receive notifications by email',
        push: 'Push Notifications',
        pushDescription: 'Receive notifications on device',
        sms: 'SMS Notifications',
        smsDescription: 'Receive notifications by text message',
        newJobs: 'New Jobs',
        newJobsDescription: 'Notifications about new job opportunities',
        jobUpdates: 'Job Updates',
        jobUpdatesDescription: 'Changes in the status of your assigned jobs',
        payments: 'Payments',
        paymentsDescription: 'Notifications about payments and transactions',
        messages: 'Messages',
        messagesDescription: 'New messages from businesses or clients',
        reminders: 'Reminders',
        remindersDescription: 'Reminders about pending jobs'
      },
      privacy: {
        title: 'Privacy Settings',
        profileVisibility: 'Profile Visibility',
        profileVisibilityDescription: 'Who can see your profile',
        showLocation: 'Show Location',
        showLocationDescription: 'Allow businesses to see your location',
        showEarnings: 'Show Earnings',
        showEarningsDescription: 'Show your earnings in public profile',
        showRating: 'Show Rating',
        showRatingDescription: 'Show your average rating',
        allowContact: 'Allow Contact',
        allowContactDescription: 'Allow businesses to contact you directly',
        dataSharing: 'Data Sharing',
        dataSharingDescription: 'Share data with third parties to improve service',
        visibility: {
          public: 'Public',
          private: 'Private',
          businesses: 'Businesses Only'
        }
      },
      work: {
        title: 'Work Preferences',
        maxDistance: 'Maximum Distance',
        minHourlyRate: 'Minimum Hourly Rate',
        availability: 'Weekly Availability',
        days: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday'
        }
      },
      app: {
        title: 'App Settings',
        theme: 'Theme',
        themeDescription: 'Select the visual theme of the app',
        soundEnabled: 'Sound Enabled',
        soundEnabledDescription: 'Play sounds in the app',
        vibrationEnabled: 'Vibration Enabled',
        vibrationEnabledDescription: 'Vibration in notifications',
        autoLocation: 'Auto Location',
        autoLocationDescription: 'Share location automatically',
        dataUsageLabel: 'Data Usage',
        dataUsageDescription: 'Configure mobile data usage',
        themes: {
          light: 'Light',
          dark: 'Dark',
          auto: 'Auto'
        },
        dataUsageOptions: {
          low: 'Low',
          medium: 'Medium',
          high: 'High'
        }
      },
      security: {
        title: 'Security Settings',
        twoFactorEnabled: 'Two-Factor Authentication',
        twoFactorEnabledDescription: 'Require additional code to sign in',
        biometricEnabled: 'Biometric Authentication',
        biometricEnabledDescription: 'Use fingerprint or Face ID',
        sessionTimeout: 'Session Timeout',
        sessionTimeoutDescription: 'Time before automatically signing out',
        loginNotifications: 'Login Notifications',
        loginNotificationsDescription: 'Receive notifications when you sign in',
        accountActions: 'Account Actions',
        exportData: 'Export Data',
        exportDataDescription: 'Download all your personal data',
        deleteAccount: 'Delete Account',
        deleteAccountDescription: 'Permanently delete your account and all data',
        export: 'Export',
        delete: 'Delete',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours'
      },
      error: {
        loading: 'Error loading settings',
        updating: 'Error updating settings',
        passwordMismatch: 'Passwords do not match',
        passwordTooShort: 'Password must be at least 6 characters',
        passwordChange: 'Error changing password',
        dataExport: 'Error exporting data',
        accountDeletion: 'Error deleting account',
        notFound: 'Settings not found'
      },
      success: {
        updated: 'Settings updated successfully',
        passwordChanged: 'Password changed successfully',
        dataExported: 'Data exported successfully',
        accountDeleted: 'Account deleted successfully'
      },
      confirm: {
        accountDeletion: 'Are you sure you want to delete your account? This action cannot be undone.'
      }
    },

    // Skills Management
    skills: {
      title: 'Skills Management',
      addSkill: 'Add Skill',
      editSkill: 'Edit Skill',
      deleteSkill: 'Delete Skill',
      skillName: 'Skill Name',
      skillNamePlaceholder: 'E.g. Carpentry, Electrical, Nursing',
      skillDescription: 'Description',
      skillDescriptionPlaceholder: 'Describe your experience in this skill',
      skillLevel: 'Level',
      skillLevels: {
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        expert: 'Expert'
      },
      skillCategory: 'Category',
      skillCategories: {
        technical: 'Technical',
        soft: 'Soft Skills',
        safety: 'Safety',
        certification: 'Certification',
        other: 'Other'
      },
      yearsOfExperience: 'Years of Experience',
      yearsOfExperiencePlaceholder: '0',
      isCertified: 'Do you have certification?',
      certificationDetails: 'Certification Details',
      certificationDetailsPlaceholder: 'Describe your certification if applicable',
      addNewSkill: 'Add New Skill',
      noSkills: 'You have no skills registered',
      noSkillsDescription: 'Add your skills to improve your profile and receive better job offers',
      saveSkill: 'Save Skill',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      searchSkills: 'Search skills...',
      filterByCategory: 'Filter by category',
      filterByLevel: 'Filter by level',
      allCategories: 'All categories',
      allLevels: 'All levels',
      skillAdded: 'Skill added successfully',
      skillUpdated: 'Skill updated successfully',
      skillDeleted: 'Skill deleted successfully',
      error: {
        loading: 'Error loading skills',
        adding: 'Error adding skill',
        updating: 'Error updating skill',
        deleting: 'Error deleting skill',
        notFound: 'Skill not found'
      },
      validation: {
        nameRequired: 'Skill name is required',
        descriptionRequired: 'Description is required',
        levelRequired: 'Level is required',
        categoryRequired: 'Category is required',
        yearsRequired: 'Years of experience is required',
        yearsPositive: 'Years of experience must be a positive number'
      }
    },

    // Roster
    roster: {
      title: 'Roster',
      registrationCode: 'Registration Code',
      codeDescription: 'Share this code with your employees so they can register in your company.',
      currentCode: 'Current code',
      copyCode: 'Copy code',
      generateCode: 'Generate code',
      regenerateCode: 'Regenerate code',
      generating: 'Generating...',
      noCodeYet: 'You haven\'t generated a registration code yet',
      codeGenerated: 'Code generated successfully',
      errorGeneratingCode: 'Error generating code',
      registrationLink: 'Registration link',
      copyRegistrationLink: 'Copy registration link',
      linkCopied: 'Link copied to clipboard',
      employees: 'Employees',
      employee: 'employee',
      employeesPlural: 'employees',
      noEmployees: 'No employees registered',
      shareRegistrationLink: 'Share the registration link for your employees to join',
      approve: 'Approve',
      reject: 'Reject',
      employeeApproved: 'Employee approved successfully',
      employeeRejected: 'Employee rejected',
      errorApprovingEmployee: 'Error approving employee',
      errorRejectingEmployee: 'Error rejecting employee',
      status: {
        pending: 'Pending',
        active: 'Active',
        inactive: 'Inactive'
      }
    },

    // Employee Registration
    employee: {
      joinTeam: 'Join the Team',
      personalInformation: 'Personal Information',
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter your first name',
      firstNameRequired: 'First name is required',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter your last name',
      lastNameRequired: 'Last name is required',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      emailRequired: 'Email is required',
      emailInvalid: 'Email is not valid',
      emailAlreadyInUse: 'This email is already in use',
      phone: 'Phone',
      phonePlaceholder: '+1234567890',
      phoneRequired: 'Phone is required',
      title: 'Title',
      titlePlaceholder: 'Ex: Engineer, Doctor, etc.',
      titleRequired: 'Title is required',
      position: 'Position',
      positionPlaceholder: 'Ex: Manager, Supervisor, etc.',
      positionRequired: 'Position is required',
      password: 'Password',
      passwordPlaceholder: 'Minimum 6 characters',
      passwordMinLength: 'Password must be at least 6 characters',
      passwordHelp: 'Minimum 6 characters',
      registrationCode: 'Registration Code',
      registrationCodePlaceholder: '6-digit code',
      registrationCodeRequired: 'Registration code is required',
      registrationCodeHelp: 'Request this code from your employer',
      invalidRegistrationCode: 'Invalid registration code',
      register: 'Register',
      registering: 'Registering...',
      registrationSuccess: 'Registration Successful!',
      pendingApproval: 'Your registration is pending approval by the company.',
      redirecting: 'You will be redirected shortly...',
      registrationError: 'Registration error. Please try again.',
      invalidLink: 'Invalid registration link',
      businessNotFound: 'Business not found',
      errorLoadingBusiness: 'Error loading business information'
    }
  }
};

export default en; 